import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuthStore } from '../utils/stores/useAuthStore';

const OverlayContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

const ModalContent = styled.div`
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    max-width: 400px;
    width: 90%;
`;

const Title = styled.h2`
    color: #333;
    margin-bottom: 1rem;
`;

const Message = styled.p`
    color: #666;
    margin-bottom: 1.5rem;
`;

interface SessionExpiredOverlayProps {
    isVisible: boolean;
}

export const SessionExpiredOverlay: React.FC<SessionExpiredOverlayProps> = ({ isVisible }: SessionExpiredOverlayProps) => {
    const navigate = useNavigate();
    const { logout } = useAuthStore();

    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                logout(navigate);
            }, 2000); // Redirect after 2 seconds

            return () => clearTimeout(timer);
        }
    }, [isVisible, logout, navigate]);

    if (!isVisible) return null;

    return (
        <OverlayContainer>
            <ModalContent>
                <Title>Session Expired</Title>
                <Message>Your session has expired. You will be redirected to the login page.</Message>
            </ModalContent>
        </OverlayContainer>
    );
}; 